import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JuridicoRoutingModule } from './juridico-routing.module';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ProcessoComponent } from './processo/processo.component';
import {PaginatorModule} from 'primeng/paginator';
import { MovimentacaoProcessoComponent } from './movimentacao-processo/movimentacao-processo.component';
import { CarouselModule } from 'primeng/carousel';
import { CardModule } from 'primeng/card';


@NgModule({
  declarations: [
    ProcessoComponent,
    MovimentacaoProcessoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    CalendarModule,
    DialogModule,
    TableModule,
    ListboxModule,
    CheckboxModule,
    InputTextModule,
    InputMaskModule,
    TooltipModule,
    DropdownModule,
    InputTextareaModule,
    CheckboxModule,
    CurrencyMaskModule,
    PaginatorModule,
    JuridicoRoutingModule,
    CarouselModule,
    CardModule
  ]
})
export class JuridicoModule { }
